import React from "react";
import { Box } from "@mui/material";
import {
  getNadiHouseHighlight,
  NadiHouseGroups,
} from "../../utils/nadiCustomEvents";

interface Props {
  houses: number[];
  event?: NadiHouseGroups;
  enabled: boolean;
  occupiedHouse?: number;
  compact?: boolean;
}

export default function NadiHouseList({
  houses,
  event,
  enabled,
  occupiedHouse,
  compact = false,
}: Props) {
  return (
    <>
      {(houses || []).map((house, index) => {
        const highlight = getNadiHouseHighlight(event, house, enabled);
        const occupied = Number(house) === Number(occupiedHouse);
        return (
          <Box
            key={`${house}-${index}`}
            component="span"
            data-house={house}
            data-highlight={highlight?.key}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: highlight ? (compact ? 18 : 22) : "auto",
              height: highlight ? (compact ? 18 : 22) : "auto",
              mr: compact ? 0.3 : 0.5,
              px: highlight ? 0.5 : 0,
              borderRadius: highlight ? "50%" : 0,
              bgcolor: highlight?.color || "transparent",
              color: highlight ? "#fff" : "inherit",
              fontSize: compact ? "0.7rem" : "0.875rem",
              fontWeight: occupied ? 900 : highlight ? 700 : 400,
            }}
          >
            {house}
          </Box>
        );
      })}
    </>
  );
}
